import { SALES_MACHINE_DEMO_URL } from 'resources/proposalTemplates/salesMachineDemoUrl'
import { useTranslate } from 'react-admin'
import TemplateLibraryCard, { CustomTemplateLibraryCardProps } from './TemplateLibraryCard'

const DefaultTemplateCard = (props: CustomTemplateLibraryCardProps) => {
  const translate = useTranslate()

  return (
    <TemplateLibraryCard
      {...props}
      body={translate('Slide-based interactive lifestyle proposal')}
      buttonText={translate('Demo')}
      header={translate('Swipe')}
      imgSrc={`${window.PUBLIC_URL}/images/proposal/template_default.png`}
      onButtonClick={() => window.open(SALES_MACHINE_DEMO_URL, '_blank', 'noopener,noreferrer')}
    />
  )
}

export default DefaultTemplateCard
